import React from 'react'
import { track } from 'track'

export const Banner: React.FC = () => {
  return (
    <>
      {/* Desktop corner ribbon */}
      <div className="hidden min-[1400px]:block fixed top-0 right-0 z-50 h-16 w-16">
        <a
          href="https://prosconslist.gumroad.com/l/pros-cons-list"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            track('event', 'banner-click', { event_label: 'desktop-ribbon' })
          }
        >
          <div className="absolute transform rotate-45 bg-blue-600 dark:bg-blue-800 text-center text-white font-semibold py-1 -right-9 top-8 w-44 cursor-pointer hover:bg-blue-700 dark:hover:bg-blue-900 transition-colors">
            Get the PDF!
          </div>
        </a>
      </div>

      {/* Mobile/Tablet bottom banner */}
      <a
        href="https://prosconslist.gumroad.com/l/pros-cons-list"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm font-semibold"
        onClick={() =>
          track('event', 'banner-click', { event_label: 'mobile-banner' })
        }
      >
        <div className="min-[1400px]:hidden fixed bottom-0 left-0 right-0 z-50 bg-blue-600 dark:bg-blue-800 text-white text-center py-3 cursor-pointer hover:bg-blue-700 dark:hover:bg-blue-900 transition-colors">
          Get the PDF!
        </div>
      </a>
    </>
  )
}
